import { Outlet } from "react-router-dom";
import AppHeader from "components/AppHeader";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";

const drawerWidth = 280; // Drawer width when open
const collapsedWidth = 72; // Drawer width when closed

const AppLayout = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const [drawerOpen, setDrawerOpen] = useState(isMobile || isTablet ? false : true);

    // Function to handle drawer toggle
    const handleDrawerToggle = () => {
        setDrawerOpen((prev) => !prev);
    };

    return (
        <Box sx={{
            height: { xs: "100dvh", sm: "100vh" },
            maxHeight: { xs: "100dvh", sm: "100vh" },
            width: "100%",
            maxWidth: "100vw",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box",
        }}>
            <AppHeader open={drawerOpen} onToggle={handleDrawerToggle} />
            <Box
                component="main"
                sx={{
                    flex: 1,
                    minHeight: 0,
                    overflow: "hidden",
                    padding: { xs: 0, md: '0.5rem' },
                    pl: '0px',
                    marginLeft: { xs: 0, md: `${drawerOpen ? drawerWidth : collapsedWidth}px` }, // Adjust margin based on drawer state
                    transition: "margin-left 0.3s ease-in-out, opacity 0.3s ease-in-out", // Smooth transition
                    opacity: 1,
                    boxSizing: "border-box",
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
};

export default AppLayout;